/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantResult } from '../../models/item-variant-result';

export interface ItemVariantTypesItemVariantTypeIdGet$Params {
  'Active-Tenant-Identifier': string;
  itemVariantTypeId: string;
}

export function itemVariantTypesItemVariantTypeIdGet(http: HttpClient, rootUrl: string, params: ItemVariantTypesItemVariantTypeIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & ItemVariantResult>> {
  const rb = new RequestBuilder(rootUrl, itemVariantTypesItemVariantTypeIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantTypeId', params.itemVariantTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & ItemVariantResult>;
    })
  );
}

itemVariantTypesItemVariantTypeIdGet.PATH = '/item-variant-types/{itemVariantTypeId}';
